import EventBus from '@/plugins/EventBus'

const useLoading = () => {
  function showLoading(loadingMessage?: string) {
    EventBus.$emit('setLoadingRequest', {
      status: true,
      text: loadingMessage || 'Carregando...',
    })
  }

  function closeLoading() {
    EventBus.$emit('clearLoadingRequest')
  }

  return {
    showLoading,
    closeLoading,
  }
}

export default useLoading
